import activationTime from './activation-time'
import assessment from './assessment'
import attachments from './attachments'
import auth from './auth'
import api from './axios'
import lessons from './lessons'
import modules from './modules'
import notifications from './notification'
import packages from './package'
import payments from './payments'
import promotions from './promotions'
import user from './user'

export default {
  auth,
  api,
  modules,
  activationTime,
  payments,
  notifications,
  user,
  packages,
  lessons,
  assessment,
  attachments,
  promotions,
}
